import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Icon,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FiTrendingUp,
  FiShield,
  FiBarChart2,
  FiDollarSign,
  FiArrowLeft,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const activities = [
  {
    icon: FiBarChart2,
    title: "مدیریت صندوق‌ها",
    desc: "مدیریت حرفه‌ای صندوق‌های سرمایه‌گذاری با رویکرد بازدهی پایدار",
  },
  {
    icon: FiTrendingUp,
    title: "تأمین مالی",
    desc: "طراحی و اجرای راهکارهای تأمین مالی از طریق بازار سرمایه",
  },
  {
    icon: FiShield,
    title: "مشاوره و پذیرش",
    desc: "مشاوره مالی تخصصی، ارزش‌گذاری و پذیرش اوراق بهادار",
  },
  {
    icon: FiDollarSign,
    title: "بازارگردانی",
    desc: "تنظیم عرضه و تقاضا و افزایش نقدشوندگی اوراق بهادار",
  },
];

export const SectionIntro = () => {
  const navigate = useNavigate();
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const iconBg = useColorModeValue("brand.100", "icon.bg");
  const iconColor = useColorModeValue("brand.500", "icon.svg");
  const cardBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const borderColor = useColorModeValue("gray.100", "gray.700");

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              معرفی شرکت
            </Heading>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              color={textColor}
              lineHeight="2"
              maxW="800px"
            >
              شرکت تأمین سرمایه امید در سال ۱۳۹۰ تأسیس شد و با اخذ مجوز از
              سازمان بورس و اوراق بهادار، فعالیت خود را به عنوان یک نهاد مالی
              تخصصی در بازار سرمایه ایران آغاز کرد. این شرکت در سال ۱۳۹۶ با نماد
              «امید» به عنوان نخستین شرکت تأمین سرمایه در بورس اوراق بهادار
              تهران پذیرفته و عرضه شد.
            </Text>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              color={textColor}
              lineHeight="2"
              maxW="800px"
            >
              رویکرد تأمین سرمایه امید بر شفافیت، پاسخ‌گویی و ایجاد ارزش پایدار
              برای ذی‌نفعان است و این شرکت می‌کوشد با اتکا به تخصص حرفه‌ای و
              ساختار سازمانی منسجم، جایگاهی قابل اعتماد در بازار سرمایه کشور
              داشته باشد.
            </Text>
          </VStack>

          <SimpleGrid
            columns={{ base: 1, sm: 2, lg: 4 }}
            spacing={{ base: 6, md: 8 }}
            w="100%"
            as={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {activities.map((item) => (
              <MotionBox
                key={item.title}
                variants={itemVariants}
                whileHover={{ y: -8, scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <Box
                  bg={cardBg}
                  p={6}
                  borderRadius="2xl"
                  border="1px solid"
                  borderColor={borderColor}
                  shadow="sm"
                  _hover={{ shadow: "xl" }}
                  transition="all 0.3s"
                  h="100%"
                  cursor="pointer"
                >
                  <VStack align="start" spacing={4}>
                    <Box
                      bg={iconBg}
                      p={3}
                      borderRadius="xl"
                      display="inline-flex"
                    >
                      <Icon
                        verticalAlign="middle"
                        as={item.icon as any}
                        boxSize={6}
                        color={iconColor}
                      />
                    </Box>
                    <Heading as="h3" size="md" color={headingColor}>
                      {item.title}
                    </Heading>
                    <Text fontSize="sm" color={textColor} lineHeight="tall">
                      {item.desc}
                    </Text>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>

          <Button
            size="lg"
            colorScheme="brand"
            variant="secondary"
            rightIcon={<Icon verticalAlign="middle" as={FiArrowLeft as any} />}
            onClick={() => navigate("/services")}
            alignSelf="center"
          >
            مشاهده خدمات
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};
